import { Component, OnInit } from '@angular/core';
import { NotifierService } from 'angular-notifier';
import { MatDialog} from '@angular/material/dialog';
import { DataService } from 'src/app/services/data.service';
import { AuthService } from 'src/app/services/auth.service';
import{ ConfirmListadoIniciativasAdminComponent} from 'src/app/components/shared/confirm-listado-iniciativas-admin/confirm-listado-iniciativas-admin.component';


interface Enlaces {
  email_usuario: string;
  id_rol: number;
  id_usuario:number;
  nombre_rol:string;
  nombre_usuario:string;
}

@Component({
  selector: 'app-enlaces',
  templateUrl: './enlaces.component.html',
  styleUrls: ['./enlaces.component.css']
})



export class EnlacesComponent implements OnInit {

  folio:number;
  justificacion:string;
  enlaceAnterior:string;
  emailEnlaceAnterior:string;
  idIniciativa:number;
  idDirGral:number;
  idTipoIniciativa:number;
  nuevosEnlaces:Enlaces[]=[];
  enlace:string;
  emailUser:string;
  loadingGeneral:boolean=false;


  constructor( 
    public dialog:MatDialog,
    private notifier: NotifierService,
    private dataService: DataService,
    private authService: AuthService) { }

  ngOnInit(): void {
    this.authService.user.subscribe((user: string) => {
      {this.emailUser = user}
    });
  }

  buscarFolio()
  {
    this.loadingGeneral=true;
    this.dataService.getEnlaceByFolio(this.folio).subscribe(
      data => {
        if (data['objData']) 
        {
          this.enlaceAnterior=data['objData']['nombre_enlace'];
          this.emailEnlaceAnterior=data['objData']['email_enlace'];
          this.idIniciativa=data['objData']['id_iniciativa'];
          //Obtenemos el detalle de la iniciativa
          this.dataService.detalleIniciativa(this.idIniciativa).subscribe(
            data => {
              if (data['objData']) 
              {
                this.idDirGral=data['objData']['id_dirgralSapSolicitante'];
                this.idTipoIniciativa=data['objData']['id_tipoIniciativa'];
                this.cargarComboEnlaces();
              }
            },
            error => {
              console.log(error);
            }
          );
        }
      },
      error => {
        console.log(error);
      }
    );

  }


  cargarComboEnlaces()
  {
    this.enlace='seleccione';
    this.dataService.getEnlacesReemplazo(this.idDirGral,this.idTipoIniciativa).subscribe(
      data => {
        if (data['data']) 
        {
          this.nuevosEnlaces=data['data'];    
          this.loadingGeneral=false;      
        }
      },
      error => {
        this.loadingGeneral=false;
        console.log(error);
      }
    );

  }



  cancelar()
  {
    this.enlace=null;
    this.folio=null;
    this.justificacion=null;
    this.emailEnlaceAnterior=null;
    this.enlaceAnterior=null;
  }


  
  //Eliminar subsecretaria con dir. gral
  guardar()
  {
    //Mostramos la ventana de confirmación
    let dialogRef = this.dialog.open(ConfirmListadoIniciativasAdminComponent,{data:{opcion:25},disableClose:true});
    dialogRef.afterClosed().subscribe(result => {
      if(result==false)
      {
      }
      else{
        this.loadingGeneral=true;
        let valores={
          id_iniciativa:this.idIniciativa,
          email_nuevoEnlace:this.enlace,
          justificacion:this.justificacion,
           userlogin:this.emailUser
         }
       this.dataService.updateEnlaceIniciativa(valores).subscribe(
         data => {
           if (data['objData']) 
           {
             this.notifier.notify(
               'success',
               'Se cambio el enlace correctamente.'
             );
             this.cancelar();
             this.loadingGeneral=false;
           }
           else{
            this.loadingGeneral=false;
             this.notifier.notify('error',data['errorMessage']);
           }
         },
         error => {
           console.error(error);
           this.loadingGeneral=false;
           this.notifier.notify(
             'error',
             'Ha ocurrido un error al intentar cambiar el enlace. Verifique su conexión de red o contacte al administrador.'
           );
         }
       );

      }
  }); 

  }

}
